import { render } from "./UserProfileViewTransactionsWithMe.vue?vue&type=template&id=10e8d14b&ts=true"
import script from "./UserProfileViewTransactionsWithMe.vue?vue&type=script&lang=ts"
export * from "./UserProfileViewTransactionsWithMe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__